import newsletter from '@molecules/newsletter';

export const initFooterFull = () => {
  if (!document.querySelector('.footer-columns')) {
    return;
  }

  const input = document.getElementById('newsletter_email_footer');
  newsletter('#form_newsletter_footer', input);
};
